<div class="k3-overrides-container">
  <table class="gt-reclass-table table table-condensed">
    <thead>
      <tr>
        <th colspan="16">K3 Overrides Allocation</th>
      </tr>
    </thead>
  </table>

  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin"></i>
    <span>Loading...</span>
  </div>
}

  @if (!loading) {

    <div class="form-fields">
      <div class="form-field">
        <label>Tax Year :</label>
        <select class="form-control"
                [(ngModel)]="selectedTaxYear"
                name="selectedTaxYear"
                (ngModelChange)="getScenarioDropDown()">
          <option value="">-- Select --</option>
          @for (taxyr of filteredTaxYearData; track $index) {
<option
                  [value]="taxyr.CODE_DISP_DESC">
            {{ taxyr.CODE_SHORT_DESC || taxyr.CODE_DISP_DESC }}
          </option>
}
        </select>
      </div>

      @if (selectedTaxYear) {
<div class="form-field">
        <label>Scenario :</label>
        @if (!loadingScenario) {
<select
                class="form-control"
                [(ngModel)]="selectedScenario"
                name="selectedScenario"
                (ngModelChange)="getFromDropdown()">
          <option value="">-- Select --</option>
          @for (option of scenarioDropDown; track $index) {
<option
                  [value]="option.VALUE">
            {{ option.LABEL }}
          </option>
}
        </select>
}
        @if (loadingScenario) {
<div class="loading-select">
          <input type="text" class="form-control" disabled placeholder="Loading...">
          <span class="loading-select-icon"><i class="fa fa-spinner fa-pulse"></i></span>
        </div>
}
      </div>
}

      @if (selectedTaxYear && selectedScenario) {
<div class="form-field">
        <label>Form :</label>
        @if (!loadingForm) {
<select
                class="form-control"
                [(ngModel)]="selectedForm"
                name="selectedForm"
                (ngModelChange)="getParentMeDropdown()">
          <option value="">-- Select --</option>
          @for (option of getForm; track $index) {
<option
                  [value]="option.VALUE">
            {{ option.LABEL }}
          </option>
}
        </select>
}
        @if (loadingForm) {
<div class="loading-select">
          <input type="text" class="form-control" disabled placeholder="Loading...">
          <span class="loading-select-icon"><i class="fa fa-spinner fa-pulse"></i></span>
        </div>
}
      </div>
}

      @if (selectedTaxYear && selectedScenario) {
<div class="form-field">
        <label>Enable/Disable :</label>
        <select class="form-control"
                [(ngModel)]="selectedEnableDisable"
                name="selectedEnableDisable">
          <option value="">-- Select --</option>
          <option value="Y">Enable</option>
          <option value="N">Disable</option>
        </select>
      </div>
}

      @if (selectedForm && (loadingParentME || loadParentMEDropdown)) {
<div class="form-field">
        <label>Parent ME(s) :</label>
        @if (!loadingParentME) {
<select
                class="form-control"
                [(ngModel)]="selectedParentMes"
                name="selectedParentMes"
                (ngModelChange)="getPshipDropdown()">
          <option value="">-- Select --</option>
          @for (option of parentMEDropDown; track $index) {
<option
                  [value]="parentMeKey(option)">
            {{ parentMeLabel(option) }}
          </option>
}
        </select>
}
        @if (loadingParentME) {
<div class="loading-select">
          <input type="text" class="form-control" disabled placeholder="Loading...">
          <span class="loading-select-icon"><i class="fa fa-spinner fa-pulse"></i></span>
        </div>
}
      </div>
}
    </div>

    @if (selectedParentMes && (loadingPship || showPship)) {
<div class="form-fields form-fields-second">
      <div class="form-field">
        <label>Partnership :</label>
        @if (!loadingPship) {
<select
                class="form-control"
                [(ngModel)]="selectedPship"
                name="selectedPship">
          <option value="">-- Select --</option>
          @for (option of getPshipDtls; track $index) {
<option
                  [value]="option.VALUE">
            {{ option.LABEL }}
          </option>
}
        </select>
}
        @if (loadingPship) {
<div class="loading-select">
          <input type="text" class="form-control" disabled placeholder="Loading...">
          <span class="loading-select-icon"><i class="fa fa-spinner fa-pulse"></i></span>
        </div>
}
      </div>
    </div>
}

    <div class="button-row">
      <button class="btn btn-info btn-sm"
              type="button"
              (click)="onSaveK3Click()">
        Save Sync
      </button>
      <button class="btn btn-default btn-sm reset-btn-no-hover"
              type="button"
              (click)="reset()">
        Reset
      </button>
    </div>
  
}
</div>

@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
